<template>
  <b-card body-class="p-0" header-class="border-0">
    <div v-show="this.loading" class="loading">
      <loading-panel></loading-panel>
    </div>
    <template v-slot:header>
      <div class="d-flex justify-content-between">
        <h3 class="mb-0 mr-3">My Recipes</h3>

        <router-link to="/recipes" class="btn base-button btn-primary btn-sm">See All</router-link>
      </div>
    </template>
      
      <el-table class="table-responsive table-flush table-recipes" header-row-class-name="thead-light" :data="recipes">
        <el-table-column label="Recipe title" min-width="315px" prop="name" sortable>
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <a :href="row.id" @click="loadRecipePage($event, row.id)" class="avatar mr-3 table__avatar avatar--grey rounded-circle">
                <b-img alt="Image placeholder" :src="row.image.absoluteUri" v-if="row.imageId" onerror="this.src='/img/recipes/icon-recipe.png';"></b-img>
                <b-img alt="Image placeholder" src="/img/recipes/icon-recipe.png" v-else></b-img>
              </a>
              <b-media-body class="table__title-wrapper">
                <a :href="row.id" @click="loadRecipePage($event, row.id)">
                  <span class="font-weight-600 name mb-0 text-sm table__title">{{ row.name }}</span>
                </a>
              </b-media-body>
            </b-media>
          </template>
        </el-table-column>

        <!-- <el-table-column label="Brand" prop="company" min-width="120px" sortable class="table__company">
          <template v-slot="{ row }">
              <badge class="badge-dot mr-4" type="">
                  <span class="font-weight-600">{{ row.brand ? row.brand.name : '' }}</span>
              </badge>
            </template>
        </el-table-column> -->
        <el-table-column label="Status" min-width="170px" prop="status" sortable>
          <template v-slot="{ row }">
            <badge class="badge-dot mr-4" type="">
              <i :class="`bg-${row.statusCode}`"></i>
              <span class="status">{{ row.statusName && row.statusName != null ? row.statusName : 'Created' }}</span>
            </badge>
          </template>
        </el-table-column>
        <el-table-column label="Author" min-width="80px">
          <template v-slot="{ row }">
            <div class="avatar-group">
              <div class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Ryan Tompson">
                <b-img :src="row.user && row.user.image && row.user.image.absoluteUri ? row.user.image.absoluteUri : '/img/DefaultUser.gif'" rounded="circle" class="avatar-sm "/>
              </div>
            </div>
          </template>
        </el-table-column>

        <!--el-table-column label="Completion" prop="completion" min-width="120px" sortable>
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              <span class="completion mr-2">{{ row.completion }}%</span>
              <div>
                <base-progress :type="row.statusType" :value="row.completion" />
              </div>
            </div>
          </template>
        </el-table-column-->

        <!--
        <el-table-column label="Actions" min-width="110px">
          <template v-slot="{ $index, row }" v-if="this.$store.getters.userIsAdmin">
            <el-dropdown trigger="click" class="dropdown">
              <span class="btn btn-sm btn-icon-only text-light mr-0 ml-1">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <b-dropdown-item @click.native="handleView($index, row)">View</b-dropdown-item>
                <b-dropdown-item @click.native="handleEdit($index, row)">Edit</b-dropdown-item>
                <b-dropdown-item>Share</b-dropdown-item>
                <b-dropdown-item>Invite</b-dropdown-item>
                <b-dropdown-item @click.native="handleDelete($index, row)">Delete</b-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        -->
      </el-table>
  </b-card>
</template>
<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import swal from 'sweetalert2';
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  name: 'my-recipes-table',
  components: {
    LoadingPanel,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    itemLimit: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      currentPage: 1,
      recipes: [],
      loading: false
    };
  },
  computed: {
    allRecipes() {
        return this.$store.state.recipes.myRecipes[1]
    },
    isLoading() {
      return this.$store.state.recipes.loading
    }
  },
  methods: {
    handleView(index, row) {
      this.$router.push(`/recipe/${row.id}`)
    },
    handleEdit(index, row) {
      this.$router.push(`/recipe/edit-recipe/${row.id}`)
    },
    handleDelete(index, row) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal.fire({
            title: 'Deleted!',
            text: `You deleted ${row.title}`,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false,
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id);
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    loadRecipePage(event, recipeId) {
      event.preventDefault();
      let route = `/recipe/${recipeId}`;

      if (route) {
        this.$router.push({
          path: route
        }).catch(() => {});
      }
    }
  },
  created() {
    const { dispatch } = this.$store;
    dispatch("recipes/getMyRecipes", {'userId':this.$store.state.authentication.user.user.id});
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    },
    allRecipes (myRecipes) {
      this.recipes = myRecipes.slice(0, 5);
    }
  }
};
</script>
